import SystemRoleComponent from "components/SystemRole/List";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import { mapStateToProps } from "store/helpers/mapState";

function SystemRole({  SetSelectedMenu,FetchDetails,location }) {

   

    useEffect(() => {
        SetSelectedMenu({
            menu: "roles",
            title: "Roles"
        })
    }, []);


    return <SystemRoleComponent FetchDetails={FetchDetails} location={location}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemRole);